import { Modal } from '@/components/ui';
import { format } from 'date-fns';
import type { ReportComment } from '@/types/dailyReports.types';

export interface ReportCommentModalProps {
  comment: ReportComment | null;
  isOpen: boolean;
  onClose: () => void;
}

export function ReportCommentModal({ comment, isOpen, onClose }: ReportCommentModalProps) {
  if (!comment) return null;

  const formattedDate = format(new Date(comment.date), 'EEEE, MMMM d, yyyy · h:mm a');

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="lg"
      className="max-w-[min(100%,36rem)] sm:max-w-2xl"
      showCloseButton
    >
      <div className="rounded-lg border border-amber-200/70 bg-gradient-to-b from-[#fdfbf7] to-[#f4efe4] px-5 py-5 shadow-[inset_0_1px_0_rgba(255,255,255,0.5)] dark:border-amber-800/40 dark:from-amber-950/50 dark:to-stone-950 sm:px-7 sm:py-6">
        <header className="border-b border-amber-900/10 pb-3 dark:border-amber-700/25">
          <time
            dateTime={comment.date}
            className="block font-serif text-base font-semibold text-amber-950 dark:text-amber-50 sm:text-lg"
          >
            {formattedDate}
          </time>
        </header>
        <div className="mt-4 whitespace-pre-wrap font-serif text-sm leading-relaxed text-amber-950/95 dark:text-amber-50/95 sm:text-base sm:leading-relaxed">
          {comment.comment}
        </div>
      </div>
    </Modal>
  );
}
